import dayjs from 'dayjs';
import {
  CopyRightIcon,
  // CopyRightText,
  // FooterLinks,
  // GI
} from '../constants';

function Footer() {
  const currentYear = dayjs().year();
  return (
    <footer className="bg-[#fff] w-full border-t border-[#E4E4E7]">
      <div className="flex items-center justify-between w-full px-6 py-2">
        <div className="flex gap-1">
          {/* <p className="text-[#A0AEC0] font-normal text-[12px] leading-[18px] m-0">
            {CopyRightIcon}
            {currentYear} Grigo.
          </p> */}
          <p className="text-[#A0AEC0] font-normal text-[12px] leading-[18px] m-0">
            {CopyRightIcon}
            {currentYear} Grigo.
            {/* {CopyRightText} */}
          </p>
          {/* <p className="text-amber-500 font-bold text-[12px] leading-[18px] m-0">{GI}</p> */}
        </div>
        {/* <div className="flex gap-3">
          {FooterLinks?.map((linkName: { label: string; link: string }) => (
            <a
              key={linkName.link}
              href={linkName.link}
              target="_blank"
              rel="noreferrer"
              className="text-[#A1A1AA] font-normal text-[12px] hover:cursor-pointer hover:underline"
            >
              {linkName.label}
            </a>
          ))}
        </div> */}
      </div>
    </footer>
  );
}

export default Footer;
